/* eslint-disable prettier/prettier */
import React from 'react'
import TheContent from './TheContent.js'
import TheHeader from './TheHeader.js'
import TheSidebar from './TheSidebar'
import TheFooter from './TheFooter.js'
import { useAuth } from '../hooks/auth'



const TheLayout = () => {
  const { user } = useAuth()

  return (
    <div className="c-app c-default-layout">
      {user && <TheSidebar />}
      <div className="c-wrapper">
        {user && <TheHeader />}
        <div className="c-body">
          <TheContent />        
        </div>
        {user && <TheFooter />}
      </div>
    </div>
  )
}

export default TheLayout
